import { isNil, isEmpty, size, last, isArray } from 'lodash';
import ServiceUrls from '@/lib/ServiceUrls';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import $moment from '../lib/util/moment';

// define a mixin object
export default {

  filters: {
    toList: function (value) {
      if (isArray(value) && !isEmpty(value)) {
        return value.join(', ');
      } else {
        return '';
      }
    },
    toAge: function (value) {
      if (isEmpty(value)) return '';

      const birthDate = $moment.utc(value, 'YYYYMMDD');
      const today = $moment();
      const age = today.diff(birthDate, 'years');

      return age;
    },
    id2number: function (value) {
      if (isEmpty(value)) return '';
      return last(value.split('::'));
    },
    toInt: function (value) {
      return `${(isNil(value) ? 0 : value).toLocaleString(
        window.i18n.locale,
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        },
      )}`;
    },
    toCurrency: function (value) {
      return `${(isNil(value) ? 0 : value).toLocaleString(
        window.i18n.locale,
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      )}`;
    },
    toNullableCurrency: function (value) {
      if (isNil(value)) return '-';
      return `${value.toLocaleString(
        window.i18n.locale,
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      )}`;
    },
    toDayMonthDate: function (value) {
      return isNil(value) ? '' : new Intl.DateTimeFormat(
        window.i18n.locale,
        {
          day: '2-digit',
          month: '2-digit',
        },
      ).format($moment(value, 'YYYYMMDD').toDate());
      // return isEmpty(value) ? '' : `${$moment(value, 'YYYYMMDD').format('DD.MM.YYYY')}`;
    },
    toDate: function (value) {
      return isNil(value) ? '' : new Intl.DateTimeFormat(
        window.i18n.locale,
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        },
      ).format(value.includes('-') ? $moment(value, 'YYYY-MM-DD').toDate() : $moment(value, 'YYYYMMDD').toDate());
      // return isEmpty(value) ? '' : `${$moment(value, 'YYYYMMDD').format('DD.MM.YYYY')}`;
    },
    toFullDate: function (value) {
      return isNil(value) ? '' : new Intl.DateTimeFormat(
        window.i18n.locale,
        {
          weekday: 'short',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        },
      ).format(value.includes('-') ? $moment(value, 'YYYY-MM-DD').toDate() : $moment(value, 'YYYYMMDD').toDate());
      // return isEmpty(value) ? '' : `${$moment(value, 'YYYYMMDD').format('DD.MM.YYYY')}`;
    },
    toDateTime: function (value) {
      return isNil(value) ? '' : new Intl.DateTimeFormat(
        window.i18n.locale,
        {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        },
      ).format($moment(value).toDate());
      // return isEmpty(value) ? '' : `${$moment(value).format('DD.MM.YYYY HH:mm:ss')}`;
    },
    toLocalDate: function (value) {
      return isNil(value) ? '' : new Intl.DateTimeFormat(
        window.i18n.locale,
        {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        },
      ).format($moment.utc(value, 'YYYYMMDD').local().toDate());
      // return isEmpty(value) ? '' : `${$moment.utc(value, 'YYYYMMDD').local().format('DD.MM.YYYY')}`;
    },
    toLocalDateTime: function (value) {
      return isNil(value) ? '' : new Intl.DateTimeFormat(
        window.i18n.locale,
        {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        },
      ).format($moment.utc(value).local().toDate());
      // return isEmpty(value) ? '' : `${$moment.utc(value).local().format('DD.MM.YYYY HH:mm:ss')}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/FilterMixin.js